module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/makeup_7ee948.jpg";